import { render } from "./EditJson.vue?vue&type=template&id=d4b8a1c6&scoped=true"
import script from "./EditJson.vue?vue&type=script&lang=js"
export * from "./EditJson.vue?vue&type=script&lang=js"

import "./EditJson.vue?vue&type=style&index=0&id=d4b8a1c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b8a1c6"]])

export default __exports__